import { createI18n } from "@rekati/i18n";
import { en } from "./en";
import { id } from "./id";

export const { I18nProvider, useI18n } = createI18n({ en, id }, "rekati.console.lang");
